import axios from 'axios';
import { req } from './axiosFun';
// 修改密码
export const UpdatePwd = (params) => { return req("post", "https://report.tyjc3935.com/api/user/change" , params) };

//创建用户
export const AddUser = (params) => { return req("post", "https://report.tyjc3935.com/api/user" , params) };



// WEBPACK FOOTER //
// ./src/api/user.js